import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./styles/globals.css";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
